<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>
          {{ 'Invoices_Title' | translateWF: 'Invoices' }}
        </h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-button [label]="'Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="redirectToDetails('new')" />
          }
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'Invoices_Title' | translateWF: 'Invoices'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="listInvoices()" dataKey="id" [lazy]="true" [sortField]="sortField()" [sortOrder]="sortOrder()" selectionMode="single" (onSort)="onSort($event)">
            <ng-template pTemplate="header">
              <tr class="cs-datatable-header-dark">
                <th pSortableColumn="invoiceNumber">
                  {{ 'Invoices_Invoice_Number' | translateWF: 'Invoice Number' }}
                  <p-sortIcon field="invoiceNumber"></p-sortIcon>
                </th>
                <th>
                  {{ 'Invoices_Provider_Invoice_Number' | translateWF: 'Provider Invoice Number' }}
                </th>
                <th>
                  {{ 'Invoices_Purchase_Order_Number' | translateWF: 'Purchase Order Associated' }}
                </th>
                <th>
                  {{ 'Invoices_Status' | translateWF: 'Status' }}
                </th>
                <th>
                  {{ 'Invoices_Issued_Date' | translateWF: 'Issued Date' }}
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-index="rowIndex">
              @let invoice = getRowData(rowData);
              <tr class="cursor-pointer" (click)="redirectToDetails(invoice.id!)">
                <td>
                  <a>{{ invoice?.invoiceNumber }}</a>
                </td>
                <td>
                  {{ invoice?.providerInvoiceNumber }}
                </td>
                <td>
                  {{ invoice?.purchaseOrderNumbers?.join(', ') }}
                </td>
                <td>
                  {{ getStatusLabel(invoice.status) }}
                </td>
                <td>
                  {{ (invoice.invoiceIssuedDate | date: 'dd-MM-yyyy') || '--------' }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="4">
                  {{ 'Invoices_No_Invoices_Found' | translateWF: 'No invoices found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[15, 25, 50, 100]"
            dropdownAppendTo="body"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
